// extracted by mini-css-extract-plugin
export default {"background":"KB","weightImage":"LB","drinkImage":"MB","content":"NB","rtbLeft":"OB","rtbRight":"PB","rtbLeftMobile":"QB","imageContainer":"RB","rtbBox":"SB","line":"TB","rtbDesktop":"UB"};
    if(module.hot) {
      // 1711394578553
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  